// extracted by mini-css-extract-plugin
export default {"validationErrorText":"FooterError-module__validationErrorText___23vJC"};